import React, {useContext} from "react";
import CredentialsContext from "../contexts/CredentialsContext";
import RequireAuth from "../auth/RequireAuth";
import { Link, Navigate } from "react-router-dom";
import { Header } from "./Header";
import getGame from "../../js/utils/async/getGame";

import "./Games.css";
import "../css/general.css";
import "../css/buttons.css";

function AuthMessage() {
    return (
      <div>
        У вас недостаточно прав для доступа к данному ресурсу. Попробуйте пройти авторизацию заново.
      </div>
    );
  }

  async function onClick(credentials, link){
    let document = await getGame(credentials, link);
    let win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=780,height=200");
    window.document = document;
  }

export default function Games(){
  let devFlag = false;
  let globalLink = devFlag ? "http://localhost:3080" : "http://185.221.153.70:1997";
  const {credentials} = useContext(CredentialsContext);
  if(!credentials){
    return <Navigate to="/login" />
  }

    return (<>
        <Header/>
        <RequireAuth roles={["admin", "developer", "expert"]} public={AuthMessage}>
        <div className="admin-panel centering">
        <h1>Выберите игру, с которой вы хотите сейчас работать</h1>
          <div className="btn-group-vertical admin-panel-sections">
            {/* <Link className="btn btn-default" to="/game" state={{link: "/games/stl/"}}>Теория государства и права 1</Link> */}
            {/* <Link className="btn btn-default" to="/games/stl">Теория государства и права</Link>
            <Link className="btn btn-default" to="/freshUser">Уголовное право</Link>
            <Link className="btn btn-default" to="/users"></Link> */}
            {credentials.games.map(elem => <div className="btn btn-default" onClick={() => window.open(globalLink + elem.link)}>
              {elem.name}
            </div>)}
            <Link className="btn btn-default" to="/dashboard">Вернуться назад</Link>
          </div>
        </div>
      </RequireAuth>
      </>
    )
}